/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Else, If, Then } from "react-if";
import { Text, Spinner } from "@nordcloud/gnui";
import { ExtendedSidebar } from "~/components/ExtendedSidebar/ExtendedSidebar";
import { SLAItem } from "~/components/SLA/SLAItem";
import { Sla } from "~/models";

type PreviewContentProps = {
  sla: Sla[];
  selectedService: {
    name: string;
    value: string;
  };
  isLoading: boolean;
};

function PreviewContent({
  sla,
  selectedService,
  isLoading,
}: PreviewContentProps) {
  const isSla = sla.length !== 0;

  return (
    <ExtendedSidebar
      isOpen={!!selectedService.name}
      title={selectedService?.name}
    >
      <If condition={isLoading}>
        <Then>
          <Spinner />
        </Then>
        <Else>
          <Text weight="medium">SLA</Text>
        </Else>
      </If>

      <If condition={isSla}>
        <Then>
          {sla?.map((s: Sla) => (
            <SLAItem isNarrow key={s?.id} sla={s} />
          ))}
        </Then>
        <Else>
          <Text color="warning" weight="medium">
            There is no SLA
          </Text>
        </Else>
      </If>
    </ExtendedSidebar>
  );
}
export { PreviewContent };
